<div
  #chart
  [style.height.px]="height"
  [style.width.%]="100"></div>
